import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, MapPin, Phone, Mail, ChevronRight, Youtube, Globe, FileText, ArrowRight } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import darkLogo from '../assets/osop logo dark.png';
import lightLogo from '../assets/osop logo light.png';
import osopOldLogo from '../assets/osopoldlogo.png';
import ResumeSubmissionModal from './ResumeSubmissionModal';

const Footer = () => {
    const { isDarkMode } = useTheme();
    const logo = isDarkMode ? lightLogo : darkLogo;
    const [showResumeModal, setShowResumeModal] = useState(false);

    const courseLinks = [
        { name: 'Full Stack Development', path: '/courses/live' },
        { name: 'Data Science', path: '/courses/aiml' },
        { name: 'DevOps Engineering', path: '/courses/live' },
        { name: 'Mobile App Development', path: '/courses/live' },
    ];

    const exploreLinks = [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/why-osop' },
        { name: 'Hire From Us', path: '/hire' },
        { name: 'Placements', path: '/placement' },
        { name: 'Franchise', path: '/franchise' },
        { name: 'Contact', path: '/contact' },
        { name: 'Enquire Now', path: '/enquire' },
    ];

    const legalLinks = [
        { name: 'About Us', path: '/why-osop' },
        { name: 'Hire From Us', path: '/hire' },
        { name: 'Privacy Policy', path: '#' },
        { name: 'Terms & Conditions', path: '#' },
        { name: 'Refund Policy', path: '#' },
    ];

    const socialLinks = [
        { icon: <Facebook className="w-5 h-5" />, href: 'https://www.facebook.com/osopcoding', label: 'Facebook' },
        { icon: <Twitter className="w-5 h-5" />, href: 'https://twitter.com', label: 'Twitter' },
        { icon: <Linkedin className="w-5 h-5" />, href: 'https://www.linkedin.com/company/osopcodingdigital/', label: 'LinkedIn' },
        { icon: <Instagram className="w-5 h-5" />, href: 'https://www.instagram.com/osopcoding/', label: 'Instagram' },
        { icon: <Youtube className="w-5 h-5" />, href: 'https://www.youtube.com/@osopcoding', label: 'YouTube' },
    ];

    return (
        <>
        <footer className="surface-secondary content-secondary relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-200/50 dark:to-gray-800/30 opacity-20"></div>

            <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12">
                    
                    {/* About Section */}
                    <div className="lg:col-span-4">
                         <div className="mb-6">
                            <img 
                                src={osopOldLogo} 
                                alt="OSOP Old Logo" 
                                className="h-16 object-contain"
                            />
                        </div>
                        <p className="text-sm leading-relaxed max-w-md mb-6 text-gray-600 dark:text-gray-400">
                            OSOPCoding is India's most premium IT Training institute founded by "Online School of Programming" Mentors with over 26 Years of legacy in IT Training. Trained more than 15000 students in classroom training. Our Mission is to Bridge Skills Gap between IT Sector and Students, We Understand Corporates Demand and Deliver World Class Technology Training to fulfil those demands.
                        </p>
                        <div className="flex flex-wrap gap-3 mt-6">
                            {socialLinks.map((social, index) => (
                                <a 
                                    key={index} 
                                    href={social.href} 
                                    aria-label={social.label}
                                    className="w-10 h-10 bg-white dark:bg-gray-800 hover:bg-primary-600 dark:hover:bg-primary-600 rounded-full flex items-center justify-center text-gray-600 dark:text-gray-400 hover:text-white transition-all duration-300 shadow-sm hover:shadow-md border border-gray-200 dark:border-gray-700"
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                   
                    {/* Popular Courses */}
                    <div className="lg:col-span-2">
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 tracking-wider">Popular Courses</h4>
                        <ul className="space-y-2">
                            {courseLinks.map((link) => (
                                <li key={link.name}>
                                    <Link to={link.path} className="text-sm flex items-center hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300">
                                        <ChevronRight className="w-4 h-4 mr-1" />
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Links Column 1 */}
                    <div className="lg:col-span-2">
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 tracking-wider">Quick Links</h4>
                        <ul className="space-y-2">
                            {exploreLinks.map((link) => (
                                <li key={link.name}>
                                    <Link to={link.path} className="text-sm flex items-center hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300">
                                        <ChevronRight className="w-4 h-4 mr-1" />
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Placement Section */}
                    <div className="lg:col-span-4 bg-gradient-to-br from-primary-50 to-primary-100 dark:from-primary-900/20 dark:to-primary-800/20 rounded-xl p-6 border border-primary-200 dark:border-primary-800">
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 tracking-wider flex items-center">
                            <FileText className="w-5 h-5 mr-2 text-primary-600 dark:text-primary-400" />
                            Placement
                        </h4>
                        <div className="space-y-4">
                            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                Ready to start your career? Submit your resume and get connected with top companies. Our placement team works with 500+ leading companies to provide excellent job opportunities.
                            </p>
                            <button
                                onClick={() => setShowResumeModal(true)}
                                className="w-full bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl transform hover:scale-105 text-sm sm:text-base"
                            >
                                <FileText className="w-4 h-4" />
                                <span>Submit Resume</span>
                                <ArrowRight className="w-4 h-4" />
                            </button>
                            <div className="text-xs text-gray-500 dark:text-gray-400 text-center">
                                Get placement opportunities from top companies
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            {/* Contact Info Section */}
            <div className="bg-gray-200/70 dark:bg-black/30 py-6 border-t border-gray-300 dark:border-gray-800 backdrop-blur-sm relative z-10">
                <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
                    <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 mb-4 md:mb-0">
                        <div className="flex items-center">
                            <MapPin className="w-4 h-4 mr-2 text-primary-600 dark:text-primary-400" />
                            <span className="text-sm text-gray-600 dark:text-gray-400">OSOPCoding Edutech, 107, Kohinoor Tower, Rajmohalla Indore, India</span>
                        </div>
                        <div className="flex items-center">
                            <Phone className="w-4 h-4 mr-2 text-primary-600 dark:text-primary-400" />
                            <a href="tel:+917649098000" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">+91 76490 98000</a>
                        </div>
                        <div className="flex items-center">
                            <Mail className="w-4 h-4 mr-2 text-primary-600 dark:text-primary-400" />
                            <a href="mailto:info@osopcoding.com" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">info@osopcoding.com</a>
                        </div>
                        <div className="flex items-center">
                            <Globe className="w-4 h-4 mr-2 text-primary-600 dark:text-primary-400" />
                            <a href="https://osopcoding.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">www.osopcoding.com</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="bg-gray-200/70 dark:bg-black/30 py-6 border-t border-gray-300 dark:border-gray-800 backdrop-blur-sm relative z-10">
                <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 md:mb-0">&copy; {new Date().getFullYear()} OSOPCoding Edutech. All Rights Reserved.</p>
                    <div className="flex space-x-6">
                        <Link to="#" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">Privacy Policy</Link>
                        <Link to="#" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">Terms of Service</Link>
                        <Link to="#" className="text-sm text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400">Cookie Policy</Link>
                    </div>
                </div>
            </div>
        </footer>

        {/* Resume Submission Modal */}
        <ResumeSubmissionModal 
            isOpen={showResumeModal} 
            onClose={() => setShowResumeModal(false)} 
        />
    </>
    );
};

export default Footer; 